import { cn } from "../../utils/cn";
import i18n from "../../i18n";

interface FilterItem {
  labelEn: string;
  labelAr: string;
  value: number;
}

interface SelectableFilterGroupProps {
  label: string;
  items: FilterItem[];
  selectedItems: number[];
  onSelectionChange: (selectedItems: number[]) => void;
}

const SelectableFilterGroup = ({
  label,
  items,
  selectedItems,
  onSelectionChange,
}: SelectableFilterGroupProps) => {
  const handleItemClick = (itemId: number) => {
    if (selectedItems.includes(itemId)) {
      onSelectionChange(selectedItems.filter((id) => id !== itemId));
    } else {
      onSelectionChange([...selectedItems, itemId]);
    }
  };

  const getItemLabel = (item: FilterItem) => {
    if (item.labelEn && item.labelAr) {
      return i18n.language === "en" ? item.labelEn : item.labelAr;
    }

    return;
  };

  return (
    <div className="flex flex-col gap-[3px]">
      <p className="text-[13px] font-normal">{label}</p>

      <div className="flex items-center gap-1 flex-wrap">
        {items.map((item) => (
          <div
            key={item.value}
            className={cn(
              "flex items-center gap-3 border max-w-max rounded-full px-2 cursor-pointer",
              selectedItems.includes(item.value)
                ? "bg-purple-primary text-white border-purple-primary"
                : "border-purple-primary bg-white text-black",
            )}
            onClick={() => handleItemClick(item.value)}
          >
            <p className="text-[13px]">{getItemLabel(item)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectableFilterGroup;
